module.exports = __webpack_public_path__ + "static/logo-509cb51f1a5fa368542afd461ae57855.png";